import { HttpClient } from '../../httpClient'

export interface DeleteNoteParams {
  workspaceSlug: string
  momentId: string
  noteId: string
}
interface DeleteNoteRequestArgs {
  params: DeleteNoteParams
}

export function deleteNote({ params }: DeleteNoteRequestArgs): Promise<void> {
  const url = new URL(
    `/moments/${params.workspaceSlug}/${params.momentId}/note/${params.noteId}`,
    window.location.origin
  )

  return HttpClient()
    .delete(url.toString())
    .then((res) => res.data)
}
